import styled from "styled-components";

import { ListSection, ListSectionTextItem, RoundBorderedContainer } from "uikit";

export const Container = styled(RoundBorderedContainer)`
  padding: ${({ theme }) => theme.padding.p24};
  width: 552px;
`;

export const PayrollRunsList = styled(ListSection)``;

export const PayrollRunItem = styled(ListSectionTextItem)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.colors.colorsNew.gray["300"]};
  margin-bottom: ${({ theme }) => theme.margin.m8};
  padding: ${({ theme }) => theme.padding.p8} 0;
`;

export const TrialEndMessageContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.colorsNew.gray["100"]};
  border-radius: 4px;
  padding: 8px 16px;
  margin-bottom: ${({ theme }) => theme.margin.m24};
`;
